import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'
import Button from 'components/Button/index'
import { Select } from 'antd'

export const CommonFlex = styled(Flex)`
  margin-top: 25px;
  width: ${props => (props?.width ? props?.width : '100%')};
`

export const Container = styled.div`
  padding: 0 60px 0 0;
`
export const ComanyDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`

export const SubTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const ImageSpan = styled.span`
  margin-left: 7px;
`
export const RightSection = styled.div`
  width: 60%;
`
export const FileInfoLi = styled.li`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  margin: 4px 0;
  color: ${COLORS.GREY_T_50_2};
`
export const Ul = styled.ul`
  padding: 0 0 0 16px;
`
export const Divider = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  margin: 20px 0px;
  height: 56px;
`
export const AddLinkspan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  text-align: center;
  color: ${COLORS.PRIMARY};
`
export const NoDataDiv = styled.div`
  margin: 50px 0;
`
export const MainWrapper = styled.div`
  padding-right: 15%;
  ${props => props?.marginBottom && `margin-bottom: ${props?.marginBottom}`}
`
export const PopoverImg = styled.embed`
  border-radius: 4.45455px;
  width: 400px;
  height: 250px;
`
export const DocumentFlex = styled(Flex)`
  gap: 10px;
`
export const PreviewDiv = styled.div`
  cursor: pointer;
`
export const FooterFlex = styled(Flex)`
  gap: 15px;
`
export const AddMediaButton = styled(Button.Secondary)`
  border: none !important;
  background: none !important;
  box-shadow: none !important;
`
export const CopyLinkDiv = styled.div`
  cursor: pointer;
`
export const StyledSelect = styled(Select)`
  width: 100% !important;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #010e30;
  .ant-select-selector {
    background-color: ${props =>
      !props.disabled
        ? props.backgroundcolor
          ? '#fafafb'
          : '#ffffff'
        : '#f5f5f5'} !important;
    border-radius: 8px !important;
    border-color: #e9e9e9 !important;
    box-shadow: none !important;
    height: 40px !important;
    padding-top: 5px !important;
    padding-left: 10px !important;
  }
  .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
    border-radius: 6px;
    color: ${props => !props.disabled && '#010e30'};
  }
  .ant-select-multiple.ant-select-lg .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
  }
  :hover {
    border-radius: 6px;
    color: #010e30;
  }
  .ant-select-dropdown-placement-bottomLeft {
    width: 1000px !important;
  }
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-placeholder {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
`
